function initGetmanMediaModalNav() {
  document.querySelectorAll('product-modal').forEach((modal) => {
    const content = modal.querySelector('.product-media-modal__content');
    const prevBtn = modal.querySelector('[data-media-modal-prev]');
    const nextBtn = modal.querySelector('[data-media-modal-next]');
    if (!content || !prevBtn || !nextBtn) return;

    const getItems = () => Array.from(content.children).filter((el) => el.hasAttribute('data-media-id'));

    const go = (direction) => {
      const items = getItems();
      if (items.length < 2) return;

      const currentIndex = items.findIndex((el) => el.classList.contains('active'));
      let nextIndex = currentIndex + direction;
      if (nextIndex < 0) nextIndex = items.length - 1;
      if (nextIndex >= items.length) nextIndex = 0;

      items.forEach((el) => el.classList.remove('active'));
      items[nextIndex].classList.add('active');
    };

    [prevBtn, nextBtn].forEach((button) => {
      button.addEventListener('pointerup', (event) => event.stopPropagation());
    });

    prevBtn.addEventListener('click', () => go(-1));
    nextBtn.addEventListener('click', () => go(1));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGetmanMediaModalNav);
} else {
  initGetmanMediaModalNav();
}
